import React from 'react';
import { Box, useTheme } from '@mui/material';

export const GoogleMaps = ({ address }) => {
	const theme = useTheme();
	const isDarkMode = theme.palette.mode === 'dark';

	return (
		<Box>
			<iframe
				title='Google Maps'
				style={{
					borderRadius: '10px',
					border: 'none',
					...(isDarkMode && { filter: 'invert(90%) hue-rotate(180deg)' }),
				}}
				width='100%'
				height='80%'
				loading='lazy'
				allowFullScreen
				referrerPolicy='no-referrer-when-downgrade'
				src={`https://www.google.com/maps/embed/v1/place?key=${process.env.REACT_APP_GOOGLE_PLACES_KEY}&q=${address}`}
			></iframe>
		</Box>
	);
};
